<template>
  <div>
    <v-row>
      <v-col>
        <CustomerDeliveryTypesComponent />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <CustomerSupportTypesComponent />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CustomerDeliveryTypesComponent from '@/components/customer/CustomerDeliveryTypesComponent.vue';
import CustomerSupportTypesComponent from '@/components/customer/CustomerSupportTypesComponent.vue';

export default {
  name: 'CustomerTaskTypes',
  components: {
    CustomerDeliveryTypesComponent,
    CustomerSupportTypesComponent
  },
  props: ['customer']
}
</script>